import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ProductosPage = lazy(() => import('../pages/productos/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const ServiciosPage = lazy(() => import('../pages/servicios/page'));
const PlanchasPerforadasPage = lazy(() => import('../pages/productos/planchas-perforadas/page'));
const MallasMetalicasPage = lazy(() => import('../pages/productos/mallas-metalicas/page'));
const MetalDesplegadoPage = lazy(() => import('../pages/productos/metal-desplegado/page'));
const FabricacionesEspecialesPage = lazy(() => import('../pages/productos/fabricaciones-especiales/page'));
const TelasNylonPage = lazy(() => import('../pages/productos/telas-nylon/page'));
const ProductosOrnamentacionPage = lazy(() => import('../pages/productos/ornamentacion/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />,
  },
  {
    path: '/productos',
    element: <ProductosPage />,
  },
  {
    path: '/productos/planchas-perforadas',
    element: <PlanchasPerforadasPage />,
  },
  {
    path: '/productos/mallas-metalicas',
    element: <MallasMetalicasPage />,
  },
  {
    path: '/productos/metal-desplegado',
    element: <MetalDesplegadoPage />,
  },
  {
    path: '/productos/fabricaciones-especiales',
    element: <FabricacionesEspecialesPage />,
  },
  {
    path: '/productos/telas-nylon',
    element: <TelasNylonPage />,
  },
  {
    path: '/productos/ornamentacion',
    element: <ProductosOrnamentacionPage />,
  },
  {
    path: '/servicios',
    element: <ServiciosPage />,
  },
  {
    path: '/contacto',
    element: <ContactoPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
